import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { userContext } from "src/context/userContext";
import { LogoIcon } from "src/components/icons/LogoIcon";
import { lazy, useContext, useState } from "react";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
const EditAsiakas = lazy(() => import("src/components/asiakas/edit/EditAsiakas"));

export default function GlobalDrawer_AsiakasListItem() {
  const { userAsiakas } = useContext(userContext) || {};
  const [isOpen, setIsOpen] = useState();
  const editKeikkaAsiakas = false;

  const handleEditKlik = () => setIsOpen(true);
  const handleCancel = () => setIsOpen(false);
  const handleSave = () => setIsOpen(false);

  if (!userAsiakas) return null;
  return (
    <>
      {isOpen && (
        <LazyLoader>
          <EditAsiakas
            isOpen={isOpen}
            onCancel={handleCancel}
            onSave={handleSave}
            asiakasId={userAsiakas?.asiakasId}
            editKeikkaAsiakas={editKeikkaAsiakas}
          />
        </LazyLoader>
      )}
      <ListItem disablePadding>
        <ListItemButton onClick={handleEditKlik}>
          <ListItemIcon>
            <LogoIcon asiakasId={userAsiakas?.asiakasId} />
          </ListItemIcon>
          <ListItemText primary={userAsiakas?.asiakasNimi} />
        </ListItemButton>
      </ListItem>
    </>
  );
}
